import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  PayrocTerminalAccountInfo,
  getPayrocTerminalAccounts,
} from 'api/admin/stores/getPayrocTerminalAccounts';

export const usePayrocTerminals = (storeId: number) => {
  const {
    isLoading,
    error,
    data = [],
    refetch,
  } = useQuery<unknown, AxiosError<{ error: string }>, PayrocTerminalAccountInfo[]>({
    queryKey: ['getPayrocTerminalAccounts', storeId],
    queryFn: async () => {
      const response = await getPayrocTerminalAccounts(storeId);
      return response.data ?? [];
    },
    retry: 1,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching terminal accounts',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
